<template>
  <div class="card" :style="{ backgroundColor: color, color: textColor }">
    <div class="details">
      <slot name="icon">
      </slot>
      <span :title="title" class="content">{{ title }}</span>
      <span class="value">{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardCard",
  props: {
    title: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false,
      default: "#0090ca"
    },
    textColor: {
      type: String,
      required: false,
      default: "#ffffff"
    },
  },
}
</script>

<style scoped>
div.card {
  position: relative;
  display: block;
  padding: 25px 15px;
  background-color: #eee;
  border-radius: 5px;
  overflow: hidden;
}

div.card .details {
  position: relative;
  z-index: 5;
  float: left;
  width: 100%;
  margin-top: -10px;
  text-align: left;
  overflow: hidden;
  width: 100%;
}

div.card .content {
  text-align: center;
  display: block;
  margin-bottom: 1em;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

div.card .value {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 50px;
  font-weight: 600;
  line-height: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-align: center;
}
</style>
